import { showClosedCmpView } from "../../services/utils";
import * as types from "./responseManagerActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  error: null,
  isError: false
};

const initialState = {
  applicants: {
    ...stateObject,
    candidateList: [],
    tabs: [],
    filters: [],
    subTabs: [],
    pageNo: 0,
    totalPage: 0,
    totalApplicants: 0,
    showFeedback: false,
    isJobLive: false,
    isCmpNew: false,
    whatsappAllowedAfterCall: false,
    showAudioOnCandidateProfile: false,
    whatsappAllowedJsDirect: false,
    showSubTabsOnCmp: true,
    statusBarArray: [],
    jobContactNumber: "",
    isScreeningApplicable: false
  },
  impressionState: { ...stateObject },
  irrelevantState: { ...stateObject },
  qualityFeedbackOptionsState: { ...stateObject },
  saveQualityFeedbackState: { ...stateObject },
  rejectionOptionsState: { ...stateObject },
  audioPlaying: { ...stateObject, url: "" },
  applicantCount: { ...stateObject, count: null },
  isActionTaken: false
};

const getJobData = (state, jobData) => {
  return showClosedCmpView(jobData);
};

export default function responseManagerReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_RM_APPLICANTS_LOADING:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          isLoading: true,
          isSuccess: false
        }
      };
    case types.GET_RM_APPLICANTS_SUCCESS:
      const isClosedJob = getJobData(state, action.payload.customJobData);
      return {
        ...state,
        applicants: {
          ...state.applicants,
          isLoading: false,
          isSuccess: true,
          error: null,
          tabs: action.payload.tabs.options,
          filters: action.payload.filters.options,
          subTabs: action.payload.sub_tabs.options,
          candidateList: action.payload.applicants,
          pageNo: action.payload.page_no,
          totalPage: action.payload.total_page,
          totalApplicants: action.payload.total_applicants,
          showFeedback: action.payload.show_candidate_quality_feedback,
          overallApplicantCount: action.payload.overall_total_candidates,
          overallTotalApplies: action.payload.overallTotalApplies || 0,
          overallDBMatches: action.payload.overallDBMatches || null,
          isJobLive: action.payload.is_job_live || isClosedJob,
          isCmpNew: action.payload.is_cmp_new,
          whatsappAllowedAfterCall:
            action.payload.wa_allowed_after_call_not_connected,
          showAudioOnCandidateProfile:
            action.payload.show_audio_on_candidate_profile,
          whatsappAllowedJsDirect: action.payload.wa_allowed_for_js_direct,
          showSubTabsOnCmp: action.payload.show_sub_tabs_on_cmp,
          liveDate: action.payload.live_date,
          jobPlan: action.payload.jobPlan,
          jobContactNumber: action.payload.job_contact_number,
          isScreeningApplicable: action.payload.isScreeningApplicable,
          overallRecommendations: action.payload.overallRecommendations || 0
        }
      };

    case types.RESET_APPLICANTS:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          candidateList: []
        }
      };
    case types.GET_RM_APPLICANTS_FAILURE:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SEND_RM_IMPRESSIONS_LOADING:
      return {
        ...state,
        impressionState: {
          ...state.impressionState,
          isLoading: true
        }
      };
    case types.SEND_RM_IMPRESSIONS_SUCCESS:
      return {
        ...state,
        impressionState: {
          ...state.impressionState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.SEND_RM_IMPRESSIONS_FAILURE:
      return {
        ...state,
        impressionState: {
          ...state.impressionState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_IRRELEVANT_LOADING:
      return {
        ...state,
        irrelevantState: {
          ...state.irrelevantState,
          isLoading: true
        }
      };
    case types.GET_IRRELEVANT_SUCCESS:
      return {
        ...state,
        irrelevantState: {
          ...state.irrelevantState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_IRRELEVANT_FAILURE:
      return {
        ...state,
        irrelevantState: {
          ...state.irrelevantState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_QUALITY_FEEDBACK_LOADING:
      return {
        ...state,
        qualityFeedbackOptionsState: {
          ...state.qualityFeedbackOptionsState,
          isLoading: true
        }
      };

    case types.GET_QUALITY_FEEDBACK_SUCCESS:
      return {
        ...state,
        qualityFeedbackOptionsState: {
          ...state.qualityFeedbackOptionsState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };

    case types.GET_QUALITY_FEEDBACK_FAILURE:
      return {
        ...state,
        qualityFeedbackOptionsState: {
          ...state.qualityFeedbackOptionsState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SAVE_QUALITY_FEEDBACK_LOADING:
      return {
        ...state,
        saveQualityFeedbackState: {
          ...state.saveQualityFeedbackState,
          isLoading: true
        }
      };

    case types.SAVE_QUALITY_FEEDBACK_SUCCESS:
      return {
        ...state,
        saveQualityFeedbackState: {
          ...state.saveQualityFeedbackState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };

    case types.SAVE_QUALITY_FEEDBACK_FAILURE:
      return {
        ...state,
        saveQualityFeedbackState: {
          ...state.saveQualityFeedbackState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_REJECTION_OPTIONS_LOADING:
      return {
        ...state,
        rejectionOptionsState: {
          ...state.rejectionOptionsState,
          isLoading: true
        }
      };

    case types.GET_REJECTION_OPTIONS_SUCCESS:
      return {
        ...state,
        rejectionOptionsState: {
          ...state.rejectionOptionsState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };

    case types.GET_REJECTION_OPTIONS_FAILURE:
      return {
        ...state,
        rejectionOptionsState: {
          ...state.rejectionOptionsState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case "UPDATE_CANDIDATE_LIST":
      return {
        ...state,
        applicants: {
          ...state.applicants,
          candidateList: action.payload
        }
      };

    case "UPDATE_IRRELEVANT_LIST":
      return {
        ...state,
        irrelevantState: {
          ...state.irrelevantState,
          payload: {
            applicants: action.payload
          }
        }
      };

    case "SET_AUDIO_PLAYING":
      return {
        ...state,
        audioPlaying: {
          ...state.audioPlaying,
          url: action.payload
        }
      };

    case types.GET_APPLICANTS_COUNT_LOADING:
      return {
        ...state,
        applicantCount: {
          ...state.applicantCount,
          isLoading: true
        }
      };

    case types.GET_APPLICANTS_COUNT_FAILURE:
      return {
        ...state,
        applicantCount: {
          ...state.applicantCount,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_APPLICANTS_COUNT_SUCCESS:
      return {
        ...state,
        applicantCount: {
          ...state.applicantCount,
          count: action.payload.count,
          isLoading: false,
          isSuccess: true,
          error: null
        }
      };

    case types.IS_ACTION_TAKEN:
      return {
        ...state,
        isActionTaken: action.isActionTaken
      };

    default:
      return state;
  }
}
